import * as React from 'react';
import { Typography, ListItem, ListItemText, ListItemIcon, ListItemButton } from '@mui/material';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useLowStockExpiringInventoryItems } from '../../../hooks/inventory/useLowStockExpiringInventoryItems';
import InventoryIcon from '@mui/icons-material/Inventory';
import { removeZeroDecimals } from '../../../utils/removeZeroDecimals';
import { useNavigate } from 'react-router-dom';
import InventoryItemView from '../modals/InventoryItemView';
import InventoryItemForm from '../forms/InventoryItemForm';
import InventoryTransactionView from '../modals/InventoryTransactionView';
import InventoryTransactionForm from '../forms/InventoryTransactionForm';
import { getInventoryItemById } from '../../../api/inventoryService';
import { getInventoryTransactionById } from '../../../api/inventoryService';

export default function LowStockExpiringInventoryListItems({ setListEmpty = null, setDoneLoading = null }) {
  const { t } = useTranslation('common');
  const navigate = useNavigate(); 

  const { items, loading, loadMore, searchFunction, resetParent } = useLowStockExpiringInventoryItems(true, 1, 100);

  const [transactionViewOpen, setTransactionViewOpen] = React.useState(false);
  const [transactionFormOpen, setTransactionFormOpen] = React.useState(false);
  const [selectedTransaction, setSelectedTransaction] = React.useState(null);

  const handleListItemClick = (item) => {
    // navigate('/inventory');
    setViewOpen(true);
    setSelectedItem(item); 
  };

  const handleEdit = (item) => {
    setSelectedItem(item);
    setFormMode("edit");
    setFormOpen(true);
  };

  const handleCreateTransaction = (item) => {
    setSelectedTransaction(null);
    setSelectedItem(item);
    setTransactionFormOpen(true);
  };

  const [viewOpen, setViewOpen] = React.useState(false);
  const [formOpen, setFormOpen] = React.useState(false);
  const [formMode, setFormMode] = React.useState("create");

  const [selectedItem, setSelectedItem] = React.useState(null);

  const onSaveSuccess = async (savedItem) => {
    await resetParent();
    const updatedItem = await getInventoryItemById(savedItem.id);
    setSelectedItem(updatedItem);
    if (!viewOpen) setViewOpen(true);
  };

  const onSaveTransactionSuccess = async (savedTransaction) => {
    await resetParent();
    const updatedItem = await getInventoryItemById(savedTransaction.item_id);
    setSelectedItem(updatedItem);

    const newTransaction = await getInventoryTransactionById(savedTransaction.id); 
    setSelectedTransaction(newTransaction);
    setTransactionViewOpen(true);
  };

  React.useEffect(() => {
    if (items.data.length !== 0)
    {
      if (setListEmpty) setListEmpty(false);
    } else {
      if (setListEmpty) setListEmpty(true);
    }
  }, [items]);

  React.useEffect(() => {
    if (!loading)
    {
      if (setDoneLoading) setDoneLoading(true);
    }
  }, [loading]);

  return (
    <>
      {loading ? (
        <></>
      ) : (
      
      items?.data?.map((item) => (
          <ListItem key={item.id}>
              <ListItemButton onClick={() => handleListItemClick(item)}>
                  <ListItemIcon>
                      <InventoryIcon fontSize='medium' color='primary' />
                  </ListItemIcon>
                  <ListItemText
                  primary={`${item.name}`}
                  secondary={ 
                  <>
                      <Typography component="span" variant="body2" color={Number(item.current_stock) <= Number(item.low_stock) ? "error" : "text.primary" }>
                      {`${removeZeroDecimals(item.current_stock)}${item.uom} in stock`}
                      </Typography><br />
                      {Number(item.current_stock) <= Number(item.low_stock) && item.supplier_notified ?
                      <>
                      <Typography component="span" variant="body2" color={Number(item.current_stock) <= Number(item.low_stock) ? "error" : "text.primary" } >
                      supplier has been notified
                      </Typography><br />
                      </>
                      : null}
                      <Typography component="span" variant="body2" color="text.secondary">
                      {item.category.name}
                      </Typography>
                      {item.expiry_date ?
                      <>
                      <br />
                      <Typography component="span" variant="body2" color="error">
                      {`Expiry Date: ${item.expiry_date}`}
                      </Typography>
                      </>
                      : null }
                  </>
                    }
                  />
              </ListItemButton>
          </ListItem>
      )))}
      <InventoryItemView 
        handleCreateTransaction={handleCreateTransaction}
        handleEdit={handleEdit}
        item={selectedItem}
        open={viewOpen}
        onClose={() => setViewOpen(false)}
      />
      <InventoryItemForm
        successCallback={onSaveSuccess}
        item={selectedItem}
        mode={formMode}
        open={formOpen}
        onClose={() => setFormOpen(false)}
      />
      <InventoryTransactionView 
        transaction={selectedTransaction}
        open={transactionViewOpen}
        onClose={() => setTransactionViewOpen(false)}
      />
      <InventoryTransactionForm
        item={selectedItem}
        successCallback={onSaveTransactionSuccess}
        transaction={selectedTransaction}
        mode={'create'}
        open={transactionFormOpen}
        onClose={() => setTransactionFormOpen(false)}
      />
    </>
  );
}